// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { Box } from "metabase/ui";

export const PickerColumn = styled(Box)`
  width: 100%;
  flex-basis: 310px;
  padding: 1rem;
` as unknown as typeof Box;
